module.exports = __webpack_public_path__ + "media/images/river/details-c8600deb87a22b53c9203c34221065fc.jpg";